module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "gutter": 40
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12,
      "md": 12,
      "sm": 24,
      "xs": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "default",
      "size": "large",
      "plain": true
    },
    on: {
      "click": function () { return _vm.setSelectedSetting(); }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.new')))]), _vm._v(" "), _c('data-table', {
    attrs: {
      "model": _vm.settings,
      "columns": ['eventTypeNames'],
      "operations": _vm.operations,
      "order": {
        sortBy: 'id'
      }
    },
    on: {
      "row-click": function (row) { return _vm.setSelectedSetting(row); }
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "md": 12,
      "sm": 24,
      "xs": 24
    }
  }, [(_vm.selectedSettings) ? _c('data-form', {
    attrs: {
      "model": "mobile-notification-settings",
      "entity": _vm.selectedSettings,
      "fields": _vm.fields,
      "beforeSubmit": _vm.beforeSubmit,
      "afterSubmit": _vm.afterSubmit
    },
    on: {
      "change": _vm.onFormChange
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f7d7592!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notification-setting/NotificationSettings.vue
// module id = 981
// module chunks = 2